import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About me`}</h2>
    <blockquote>
      <p parentName="blockquote">{`As a self-taught developer I had the chance to broaden my horizon by learning on Udemy, Egghead, Frontend Masters,
Wroclaw meetings, publishing platforms like Medium, or MDN Web Docs.
That enabled me to work in a great software development company.`}</p>
    </blockquote>
    <p>{`Before that, I worked as a sales representative. It is amazing how many people I have met have needed websites or mobile applications. I started learning and discovered my passion for front-end stack. While learning I enjoy development more than my earlier job, the time in this sector greatly improved my overall experience and skills.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      